import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HeaderHelperService } from '../header-helper.service';
import { CreateChatModel } from '../../models/chat/create-chat-model';
import { MessageListResponse } from '../../models/chat/message-list-response.model';
import { SendMessageRequest, SendMessageResponse } from '../../models/chat/send-message.model';
import { UploadFileRequest, UploadFileResponse } from '../../models/chat/upload-file.model';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(
    private http: HttpClient,
    private headerHelperService: HeaderHelperService
  ) {}

  /**
   * Get paginated list of messages for a group
   */
  getListMessage(groupId: string, page: number = 1, size: number = 20): Observable<MessageListResponse> {
    const url = `${environment.apiLocations.chat}/chat/getListMessage`;
    const params = {
      GroupId: groupId,
      Page: page.toString(),
      Size: size.toString()
    };

    return this.http.get<MessageListResponse>(url, {
      headers: this.headerHelperService.getHeaders(),
      params
    });
  }

  /**
   * Send a message to a group
   */
  sendMessage(request: SendMessageRequest): Observable<SendMessageResponse> {
    const url = `${environment.apiLocations.chat}/chat/sendMessage`;
    
    return this.http.post<SendMessageResponse>(url, request, {
      headers: this.headerHelperService.getHeaders()
    });
  }

  /**
   * Upload a file attachment
   */
  uploadFile(request: UploadFileRequest): Observable<UploadFileResponse> {
    const url = `${environment.apiLocations.chat}/chat/uploadFile`;
    const formData: FormData = new FormData();
    
    formData.append('file', request.file, request.file.name);
    formData.append('groupId', request.groupId);
    formData.append('senderId', request.senderId);
    formData.append('senderName', request.senderName);

    // Don't set Content-Type header - let browser set it automatically with boundary
    const headers = this.headerHelperService.getHeaders().delete('Content-Type');

    return this.http.post<UploadFileResponse>(url, formData, {
      headers: headers
    });
  }

  // Legacy methods - keeping for backward compatibility
  chatList(patientRecordCaseId: string): Observable<any> {
    let url = `${environment.apiLocations.chat}/chat/${patientRecordCaseId}`;

    return this.http.get<any>(url, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  chat(createChatModel: CreateChatModel): Observable<any> {
    const url = `${environment.apiLocations.chat}/chat/${createChatModel.patientRecordCaseId}`;
    const formData: FormData = new FormData();
    formData.append('PatientRecordCaseId', createChatModel.patientRecordCaseId);
    formData.append('PatientName', createChatModel.patientName);
    formData.append('PatientSurname', createChatModel.patientSurname);
    formData.append(
      'PatientRecordCaseNumber',
      createChatModel.patientRecordCaseNumber.toString()
    );
    formData.append('CreatedUserName', createChatModel.createdUserName);
    formData.append('ExpertUserName', createChatModel.expertUserName);
    formData.append(
      'GeneralPractitionerUserName',
      createChatModel.generalPractitionerUserName
    );
    formData.append('Message', createChatModel.message);

    if (createChatModel.file) {
      formData.append('File', createChatModel.file, createChatModel.file.name);
    }

    return this.http.post<any>(url, formData, {
      headers: this.headerHelperService.getHeaders(),
    });
  }

  userAvatars(data: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiLocations.identity}/Users/GetUserAvatars`,
      data,
      {
        headers: this.headerHelperService.getHeaders(),
      }
    );
  }
}

